import { Directive, HostListener, Input } from '@angular/core';
import { AnalyticsService } from '../../core/services/analytics-service';

@Directive({
  selector: '[appGtmFormEvent]',
  standalone: true
})
export class GtmFormEventDirective {
  @Input() public eventField: string;
  @Input() public eventForm: string;

  constructor(private analyticsService: AnalyticsService) {}

  @HostListener('focus')
  public onFocus(): void {
    this.analyticsService.trackGtmFormEvent( this.eventField, this.eventForm);
  }
}
